// extracted by mini-css-extract-plugin
export default {"widgetButton":"styles__widgetButton___JBlxP","langPreview":"styles__langPreview___dmpXS","langWidgetMenu":"styles__langWidgetMenu___LDo6X"};